export default {
  background: {
    signin_bg_image: 'https://fruitsale.jp/assets/signin-bg-image.jpg',
    top_hero_pc: 'https://fruitsale.jp/assets/hero-top-pc.jpg',
    top_hero_mobile: 'https://fruitsale.jp/assets/hero_top_mobile.jpg',
  },
  logo: {
    twitter:
      'https://fruitsale.jp/assets/Twitter_Social_Icon_Rounded_Square_Color.png',
    line: 'https://fruitsale.jp/assets/LINE_Icon.png',
    facebook: 'https://fruitsale.jp/assets/FB-f-Logo__blue_50.png',
  },
  icon: {
    social: {},
    mail: 'https://fruitsale.jp/assets/mail.png',
    arrow_left: 'https://fruitsale.jp/assets/arrow-left.svg',
    arrow_right: 'https://fruitsale.jp/assets/arrow-right.svg',
  },
  creditCard: {
    security:
      'https://fruitsale.jp/assets/b8017c7ee623fb4ad63f2b35d1855dee1.png',
  },
};
